import { http } from '../../utils/http'
export const QCBASE = window.$envUtils('VUE_APP_QC_SERVICE')

export const queryWordClassGroup = () => {
  return http.get(`${QCBASE}/mgr/wordClass/semanticManagement`)
}

export const saveWordClassGroup = (params) => {
  return http.post(`${QCBASE}/mgr/wordClass/semanticManagement`, { params }, { headers: { 'Content-Type': 'application/json' } })
}

export const deleteSemanticManagement = (params) => {
  return http.delete(`${QCBASE}/mgr/wordClass/semanticManagement`, { params })
}

export const updateSemanticManagement = (params) => {
  return http.put(`${QCBASE}/mgr/wordClass/semanticManagement`, { data: params }, { headers: { 'Content-Type': 'application/json' } })
}

export const searchKeyWord = (params) => {
  return http.get(`${QCBASE}/mgr/wordClass/keyWord`, { params })
}

export const deleteKeyWord = (params) => {
  return http.delete(`${QCBASE}/mgr/wordClass/keyWord`, { params })
}

export const updateKeyWord = (params) => {
  return http.put(`${QCBASE}/mgr/wordClass/keyWord`, { params }, { headers: { 'Content-Type': 'application/json' } })
}
export const moveKeyWord = (params) => {
  return http.put(`${QCBASE}/mgr/wordClass/moveKeyWord`, { params }, { headers: { 'Content-Type': 'application/json' } })
}

export const saveKeyWord = (params) => {
  return http.post(`${QCBASE}/mgr/wordClass/keyWord`, { params }, { headers: { 'Content-Type': 'application/json' } })
}

export const batchDeleteKeyWord = (params) => {
  return http.delete(`${QCBASE}/mgr/wordClass/batchKeyWord`, { params })
}

export const exportKeyWords = (params) => {
  return http.get(`${QCBASE}/mgr/wordClass/exportKeyWords`, { params, responseType: 'blob' })
}

export const downloadTemplate = () => {
  return http.get(`${QCBASE}/mgr/wordClass/downloadTemplate`, { responseType: 'blob' })
}
